module.exports = __webpack_public_path__ + "img/wheel.3418f980.jpg";